var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningTriangle64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.5,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.047 12.793l18.76 32.182A7 7 0 0150.76 55.5H13.24a7 7 0 01-6.048-10.525l18.76-32.182a7 7 0 0112.095 0z",
    stroke: "currentColor",
    strokeOpacity: 0.5,
    strokeWidth: 3,
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 21a3.15 3.15 0 013.134 3.48l-1.477 14.028a1.666 1.666 0 01-3.314 0l-1.477-14.027A3.15 3.15 0 0132 21z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 46,
    r: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangle64);
export default __webpack_public_path__ + "static/media/warning-triangle-64.7ab030f8.svg";
export { ForwardRef as ReactComponent };